/* eslint-disable react-refresh/only-export-components -- shared task-link config table, not a component module */
import {
  Organization,
  Partners,
  Diamond,
  Magnet,
  People,
  Contracts
} from "@dreamhub/designsystem/icons";
import IconContainer, { IconColor } from "@/components/ui/icon-container";
import { GlobalSearchFilterTypes } from "@/components/GlobalSearch/types";
import { EntityType } from "@/services/hooks/entities/entityTypes";

type TaskLinkIcon = typeof Organization;

interface TaskLinkTypeConfig {
  icon: TaskLinkIcon | null;
  translationKey: string;
  searchFilter: GlobalSearchFilterTypes | null;
}

/** Single source of truth for how each entity type appears as a task link. */
const taskLinkTypes: Record<EntityType, TaskLinkTypeConfig> = {
  [EntityType.COMPANY]: {
      icon: Organization,
      translationKey: "objectEntities.company",
      searchFilter: GlobalSearchFilterTypes.COMPANIES
    },
    [EntityType.PARTNER]: {
      icon: Partners,
      translationKey: "objectEntities.partner",
      searchFilter: GlobalSearchFilterTypes.PARTNERS
    },
    [EntityType.DEAL]: {
      icon: Diamond,
      translationKey: "objectEntities.deal",
      searchFilter: GlobalSearchFilterTypes.DEALS
    },
    [EntityType.LEAD]: {
      icon: Magnet,
      translationKey: "objectEntities.lead",
      searchFilter: GlobalSearchFilterTypes.LEADS
    },
    [EntityType.PERSON]: {
      icon: People,
      translationKey: "objectEntities.person",
      searchFilter: GlobalSearchFilterTypes.PEOPLE
    },
    [EntityType.PARTNER_CONTACT]: {
      icon: People,
      translationKey: "objectEntities.partnerContact",
      searchFilter: GlobalSearchFilterTypes.PEOPLE
    },
    [EntityType.CONTRACT]: {
      icon: Contracts,
      translationKey: "objectEntities.contract",
      searchFilter: GlobalSearchFilterTypes.CONTRACTS
    },
  [EntityType.USER]: {
    icon: null,
    translationKey: "",
    searchFilter: null
  }
};

export const renderTaskLinkIcon = (
  entityType: EntityType | undefined,
  color?: IconColor
) => {
  const Icon = entityType === undefined ? null : taskLinkTypes[entityType].icon;
  return (
    <IconContainer size="sm" color={color}>
      {Icon ? <Icon /> : null}
    </IconContainer>
  );
};

export const getTaskLinkTypeKey = (
  entityType: EntityType | undefined
): string =>
  entityType === undefined ? "" : taskLinkTypes[entityType].translationKey;

export const getFilterEntityTypes = (
  filter: GlobalSearchFilterTypes
): EntityType[] | null => {
  if (filter === GlobalSearchFilterTypes.ALL) return null;
  return Object.entries(taskLinkTypes).reduce<EntityType[]>(
    (entityTypes, [entityType, config]) => {
      if (config.searchFilter === filter) {
        entityTypes.push(Number(entityType) as EntityType);
      }
      return entityTypes;
    },
    []
  );
};
